module.exports = __webpack_public_path__ + "img/Logo.ab77e2da.svg";